import { RenderInfo } from "../../renders/RenderInfo";
import { Texture2D } from "../../resource/Texture2D";
import { TextureFormat } from "../../RenderEngine/RenderEnum/TextureFormat";
import { FilterMode } from "../../RenderEngine/RenderEnum/FilterMode";
import { WrapMode } from "../../RenderEngine/RenderEnum/WrapMode";
import { LayaEnv } from "../../../LayaEnv";
import { LayaGL } from "../../layagl/LayaGL";
import { Render } from "../../renders/Render";
import { TextRenderConfig } from "./TextRenderConfig";
export class TextTexture extends Texture2D {
    constructor(textureW, textureH) {
        super(textureW, textureH, TextureFormat.R8G8B8A8, false, false, true, true);
        this.genID = 0;
        this.curUsedCovRate = 0;
        this.curUsedCovRateAtlas = 0;
        this.lastTouchTm = 0;
        this.ri = null;
        this._discardTm = 0;
        this.setPixelsData(null, true, false);
        this.lock = true;
        this.filterMode = FilterMode.Bilinear;
        this.wrapModeU = WrapMode.Clamp;
        this.wrapModeV = WrapMode.Clamp;
        if (TextRenderConfig.debugUV) {
            this.fillWhite();
        }
    }
    addChar(data, x, y, uv) {
        if (TextRenderConfig.useImageData) {
            var dt = data.data;
            if (data.data instanceof Uint8ClampedArray)
                dt = new Uint8Array(dt.buffer);
            LayaGL.textureContext.setTextureSubPixelsData(this._texture, dt, 0, false, x, y, data.width, data.height, true, false);
        }
        else {
            LayaGL.textureContext.setTextureSubImageData(this._texture, data, x, y, true, false);
        }
        let u0;
        let v0;
        let u1;
        let v1;
        if (LayaEnv.isConch || dt != null) {
            u0 = x / this.width;
            v0 = y / this.height;
            u1 = (x + data.width) / this.width;
            v1 = (y + data.height) / this.height;
        }
        else {
            u0 = (x + 1) / this.width;
            v0 = (y + 1) / this.height;
            u1 = (x + data.width - 1) / this.width;
            v1 = (y + data.height - 1) / this.height;
        }
        uv = uv || new Array(8);
        uv[0] = u0, uv[1] = v0;
        uv[2] = u1, uv[3] = v0;
        uv[4] = u1, uv[5] = v1;
        uv[6] = u0, uv[7] = v1;
        return uv;
    }
    fillWhite() {
        var dt = new Uint8Array(this.width * this.height * 4);
        dt.fill(0xff);
        LayaGL.textureContext.setTextureImageData(this._getSource(), dt, true, false);
    }
    discard() {
        Render.setGlobalRepaint();
        this.destroy();
        return;
    }
    static getTextTexture(w, h) {
        return new TextTexture(w, h);
    }
    static clean() {
        var curtm = RenderInfo.loopStTm;
        if (TextTexture.cleanTm === 0)
            TextTexture.cleanTm = curtm;
        if (curtm - TextTexture.cleanTm >= TextRenderConfig.checkCleanTextureDt) {
            for (let i = 0; i < TextTexture.poolLen; i++) {
                var p = TextTexture.pool[i];
                if (curtm - p._discardTm >= TextRenderConfig.destroyUnusedTextureDt) {
                    p.destroy();
                    TextTexture.pool[i] = TextTexture.pool[TextTexture.poolLen - 1];
                    TextTexture.poolLen--;
                    i--;
                }
            }
            TextTexture.cleanTm = curtm;
        }
    }
    touchTexture() {
        let frame = RenderInfo.loopCount;
        if (this.lastTouchTm != frame) {
            this.curUsedCovRate = 0;
            this.curUsedCovRateAtlas = 0;
            this.lastTouchTm = frame;
        }
    }
    touchRect(ri) {
        var texw2 = TextRenderConfig.atlasWidth * TextRenderConfig.atlasWidth;
        var gridw2 = TextRenderConfig.atlasGridW * TextRenderConfig.atlasGridW;
        this.curUsedCovRate += (ri.bmpWidth * ri.bmpHeight) / texw2;
        this.curUsedCovRateAtlas += (Math.ceil(ri.bmpWidth / TextRenderConfig.atlasGridW) * Math.ceil(ri.bmpHeight / TextRenderConfig.atlasGridW)) / (texw2 / gridw2);
    }
}
TextTexture.pool = new Array(10);
TextTexture.poolLen = 0;
TextTexture.cleanTm = 0;
